// import React from "react";
import TagListPage from "./account/tags";
import SmartGroupListPage from "./account/smartGroup";
import UserListPage from "./account/user";
import AppStore from "./app/appStore";
import CompanyStore from "./app/companyStore";
import CertificateListPage from "./certificate/certificate.list";
import DeviceListPage from "./device/device.list";
import { EnrollmentAndroid } from "./enrollment/enrollment.android";
import { EnrollmentIOS } from "./enrollment/enrollment.ios";
import { EnrollmentIOSABM } from "./enrollment/enrollment.ios.abm";
import { EnrollmentIOSAPN } from "./enrollment/enrollment.ios.apn";
import { EnrollmentIOSVPP } from "./enrollment/enrollment.ios.vpp";
import MacEnrollmentSetting from "./enrollment/enrollment.preSetting";
import OpenApi from "./openapi/openapi";
import Overview from "./overview/overview";
// import { EnrollmentMacOS } from "./enrollment/enrollment.mac";
import ClassPage from "./account/class";
import LogListPage from "./account/log";
import ManagerIndex from "./account/manager";
import NoticeIndex from "./account/notice";
import { AppHistoryDetail } from "./app/app.history.detail";
import { AppInstallDetail } from "./app/appInstall.detail";
import AssetAllocation from "./asset/allocation";
import AssetGroup from "./asset/group";
import DocListPage from './content/docs';
import NotificationListPage from './content/notification';
import { DeviceDetailList } from "./device/device.detail";
import TemplateAppIndex from "./device/template/template.app";
import TemplateAppInstall from "./device/template/template.app.install";
import { TemplateAppInstallDetail } from "./device/template/template.app.install.detail";
import TemplateDevice from "./device/template/template.device";
import TemplateIndex from "./device/template/template.index";
import { Help } from "./help/help";
import ClassDevice from "./account/class.device";
import classDevice from "./account/class.device";
import templateMacIndex from "./device/template/template.mac.index";
import TemplateMacDevice from "./device/template/template.mac.device";
import SignContentListPage from './sign/contents';
import SignPlayPlanListPage from './sign/playplans';
import MacAppRestrictionDevice from "./device/mac/mac.appRestriction.device";
import MacAppRestrictionIndex from "./device/mac/mac.appRestriction.index";
import MacScriptListPage from './content/mac.scripts';
import MacCommandPolicyDevice from "./device/mac/mac.commandPolicy.device";
import MacCommandPolicyIndex from "./device/mac/mac.commandPolicy.index";
import MacLocalAppDevice from "./device/mac/mac.localApp.device";
import MacLocalAppIndex from "./device/mac/mac.localApp.index";
import {TagValueDevice} from "./account/tags.device";
import {SmartGroupDevice} from "./account/smartGroups.device";
import LdapIndex from "./account/ldap";
import FeishuIndex from "./account/feishu";
import { Organization } from "./account/organization";

interface RouteModal {
  key: string;
  path: string;
  compoent?: React.ComponentType<any>;
  exact?: boolean;
}

export const routes: RouteModal[] = [
  {
    key: "/home/index",
    path: "/home/index",
    compoent: Overview,
  },
  {
    key: "/home/devices/details/:id",
    path: "/home/devices/details/:id",
    compoent: DeviceDetailList,
  },
  {
    key: "/home/profiles/devices/:id",
    path: "/home/profiles/devices/:id",
    compoent: TemplateDevice,
  },  
  {
    key: "/home/profiles/mac/devices/:id",
    path: "/home/profiles/mac/devices/:id",
    compoent: TemplateMacDevice,
  },
  {
    key: "/home/devices/list",
    path: "/home/devices/list",
    compoent: DeviceListPage,
  },
  {
    key: "/home/apps/appStore",
    path: "/home/apps/appStore",
    compoent: AppStore,
  },
  {
    key: "/home/apps/enterpriseapps",
    path: "/home/apps/enterpriseapps",
    compoent: CompanyStore,
  },
  {
    key: "/home/apps/:id",
    path: "/home/apps/:id",
    compoent: AppInstallDetail,
  },
  {
    key: "/home/apphistory/:id",
    path: "/home/apphistory/:id",
    compoent: AppHistoryDetail,
  },
  {
    key: "/home/enrollments/androids",
    path: "/home/enrollments/androids",
    compoent: EnrollmentAndroid,
  },
  {
    key: "/home/enrollments/settings/apples/APN",
    path: "/home/enrollments/settings/apples/APN",
    compoent: EnrollmentIOSAPN,
  },

  {
    key: "/home/enrollments/settings/apples/ABM",
    path: "/home/enrollments/settings/apples/ABM",
    compoent: EnrollmentIOSABM,
  },
  {
    key: "/home/enrollments/settings/apples/VPP",
    path: "/home/enrollments/settings/apples/VPP",
    compoent: EnrollmentIOSVPP,
  },
  {
    key: "/home/enrollments/settings/apples/preEnrollment",
    path: "/home/enrollments/settings/apples/preEnrollment",
    compoent: MacEnrollmentSetting,
  },
  {
    key: "/home/enrollments/apples",
    path: "/home/enrollments/apples",
    compoent: EnrollmentIOS,
  },
  // {
  //   key: "/home/enrollment/mac",
  //   path: "/home/enrollment/mac",
  //   compoent: EnrollmentMacOS,
  // },
  {
    key: "/home/settings/organizations",
    path: "/home/settings/organizations",
    compoent: Organization,
  },
  {
    key: "/home/devices/groups",
    path: "/home/devices/groups",
    compoent: TagListPage,
  },
  {
    key: "/home/devices/smartGroups",
    path: "/home/devices/smartGroups",
    compoent: SmartGroupListPage,
  },
  {
    key: "/home/devices/groupDevices/:id",
    path: "/home/devices/groupDevices/:id",
    compoent: TagValueDevice,
  },
  {
    key: "/home/devices/smartGroupDevices/:id",
    path: "/home/devices/smartGroupDevices/:id",
    compoent: SmartGroupDevice,
  },
  {
    key: "/home/settings/users",
    path: "/home/settings/users",
    compoent: UserListPage,
  },
  // {
  //   key: "/home/settings/empower",
  //   path: "/home/settings/empower",
  //   compoent: EmpowerManage,
  // },
  // {
  //   key: "/home/settings/account",
  //   path: "/home/settings/account",
  //   compoent: AccountCreatePage,
  // },
  {
    key: "/home/contents/documents",
    path: "/home/contents/documents",
    compoent: DocListPage,
  },
  {
    key: "/home/contents/messages",
    path: "/home/contents/messages",
    compoent: NotificationListPage,
  },
  {
    key: "/home/profiles/index",
    path: "/home/profiles/index",
    compoent: TemplateIndex,
  },
  {
    key: "/home/settings/rabc",
    path: "/home/settings/rabc",
    compoent: ManagerIndex,
  },
  {
    key: "/home/help",
    path: "/home/help",
    compoent: Help,
  },
  {
    key: "/home/reports/assetgroups",
    path: "/home/reports/assetgroups",
    compoent: AssetGroup,
  },
  {
    key: "/home/reports/assetcharts",
    path: "/home/reports/assetcharts",
    compoent: AssetAllocation,
  },
  {
    key: "/home/settings/reminds",
    path: "/home/settings/reminds",
    compoent: NoticeIndex,
  },
  {
    key: "/home/contents/certificates",
    path: "/home/contents/certificates",
    compoent: CertificateListPage,
  },
  {
    key: "/home/reports/logs",
    path: "/home/reports/logs",
    compoent: LogListPage,
  },
  {
    key: "/home/profiles/classes",
    path: "/home/profiles/classes",
    compoent: ClassPage,
  },
  {
    key: "/home/profiles/appIndex",
    path: "/home/profiles/appIndex",
    compoent: TemplateAppIndex,
  },
  {
    key: "/home/openapi/list",
    path: "/home/openapi/list",
    compoent: OpenApi,
  },
  {
    key: "/home/profiles/appinstall/:id",
    path: "/home/profiles/appinstall/:id",
    compoent: TemplateAppInstall,
  },
  {
    key: "/home/profiles/apps/:id",
    path: "/home/profiles/apps/:id",
    compoent: TemplateAppInstallDetail,
  },  
  {
    key: "/home/classes/devices/:id",
    path: "/home/classes/devices/:id",
    compoent: classDevice,
  },  
  {
    key: "/home/profiles/macIndex",
    path: "/home/profiles/macIndex",
    compoent: templateMacIndex,
  },
  {
    key: "/home/sign/contents",
    path: "/home/sign/contents",
    compoent: SignContentListPage,
  },
  {
    key: "/home/sign/playplans",
    path: "/home/sign/playplans",
    compoent: SignPlayPlanListPage,
  },
  {
    key: "/home/mac/appRestriction/index",
    path: "/home/mac/appRestriction/index",
    compoent: MacAppRestrictionIndex,
  },
  {
    key: "/home/mac/appRestriction/devices/:id",
    path: "/home/mac/appRestriction/devices/:id",
    compoent: MacAppRestrictionDevice,
  },  
  {
    key: "/home/contents/scripts",
    path: "/home/contents/scripts",
    compoent: MacScriptListPage,
  },
  {
    key: "/home/mac/commandPolicy/index",
    path: "/home/mac/commandPolicy/index",
    compoent: MacCommandPolicyIndex,
  },
  {
    key: "/home/mac/commandPolicy/devices/:id",
    path: "/home/mac/commandPolicy/devices/:id",
    compoent: MacCommandPolicyDevice,
  },  
  {
    key: "/home/mac/localApp/index",
    path: "/home/mac/localApp/index",
    compoent: MacLocalAppIndex,
  },
  {
    key: "/home/mac/localApp/devices/:id",
    path: "/home/mac/localApp/devices/:id",
    compoent: MacLocalAppDevice,
  },  
  {
    key: "/home/settings/ldaps",
    path: "/home/settings/ldaps",
    compoent: LdapIndex,
  },  
  {
    key: "/home/settings/feishus",
    path: "/home/settings/feishus",
    compoent: FeishuIndex,
  },
];
